import { render, staticRenderFns } from "./EmployeeCreateAndUpdateFormItems.vue?vue&type=template&id=a2630054&"
import script from "./EmployeeCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./EmployeeCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2630054')) {
      api.createRecord('a2630054', component.options)
    } else {
      api.reload('a2630054', component.options)
    }
    module.hot.accept("./EmployeeCreateAndUpdateFormItems.vue?vue&type=template&id=a2630054&", function () {
      api.rerender('a2630054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmployeeCreateAndUpdateFormItems.vue"
export default component.exports